import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../../assets/images/logo.png";
// import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import NavMenu from "./navMenu";

const Header = (props) => {
  
  return (
    <header className="container mx-auto h-20" >
      <div className="p-4">
        <div className="flex justify-between items-center">
          <Link to="/">
            <img className="z-50 absolute top-3" src={logo} width={200} height={"auto"} alt="Logo" />
          </Link>
          <NavMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
